import InfoItem from '@/components/common/InfoItem/InfoItem';
import StoreAddressInfoItem from '@/components/common/StoreAddressInfoItem/StoreAddressInfoItem';
import { convertUnixTimestamp } from '@/helpers/convertUnixTimestamp';

export default function StoreInformation ({ storeData }) {
  // Add null check - if storeInformation doesn't exist, use an empty object
  const storeInfo = storeData?.storeInformation || {};
  console.log('storeinfo', storeInfo);
  return (
    <div className='space-y-6 px-4 text-sm'>
      <div className='grid grid-cols-3 gap-y-6'>
        <InfoItem label='Platform Type' value={storeInfo.platformType} />
        <InfoItem
          label='Last View'
          value={
            storeInfo?.lastView
              ? convertUnixTimestamp(storeInfo?.lastView)
              : '-'
          }
        />
        <InfoItem
          label='Rewards Engine Application UserID'
          value={storeInfo?.rewardApplicationUserId}
        />

        <InfoItem
          label='Last Active Date'
          value={
            storeInfo?.lastActiveDate
              ? convertUnixTimestamp(storeInfo?.lastActiveDate)
              : '-'
          }
        />
        <InfoItem label='Current Points' value={storeInfo?.currentPoints} />
        <InfoItem
          label='Deleted Reward Points'
          value={storeInfo?.deletedRewardPoints}
        />

        <InfoItem
          label='Store Registration Date'
          value={
            storeInfo?.storeRegistrationDate
              ? convertUnixTimestamp(storeInfo?.storeRegistrationDate)
              : '-'
          }
        />
        <InfoItem label='Billing Type' value={storeInfo?.billingType} />
        <InfoItem
          label='Club+'
          value={storeInfo?.clubPlus ? 'Active' : 'Inactive'}
        />
      </div>
      <StoreAddressInfoItem
        address={storeInfo?.address}
        storeInfo={storeInfo}
      />
    </div>
  );
}
